export const PRICE_DROPDOWN_LABEL_TEXT = "Price";
export const PRICE_SLIDER_HEADER_TEXT = "Set max price";
